import { render } from "./TheHeader.vue?vue&type=template&id=5ae88c88&scoped=true&ts=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.scss?vue&type=style&index=0&id=5ae88c88&lang=scss&scoped=true"

import exportComponent from "C:\\WORK\\MAPO\\hrm-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae88c88"]])

export default __exports__